import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.css']
})
export class CandidateComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
    if (localStorage.getItem('role') != 'candidate') {
      if (localStorage.getItem('role') === 'employer')
        this.router.navigate(['/employer-dashboard'])
      else
        this.router.navigate([''])
    }
  }

}
